import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgSelectModule } from '@ng-select/ng-select';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { ServicesModule } from './services/services.module';
import { AdminAuthGuard, AuthGuard } from './guards/auth.guard';
import { PipesModule } from './pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgSelectModule,
    NgxSliderModule,
    HighchartsChartModule,
    ServicesModule,
    PipesModule,
  ],
  exports: [
    FlexLayoutModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgSelectModule,
    NgxSliderModule,
    HighchartsChartModule,
    ServicesModule,
    PipesModule
  ],
  declarations: [],
  providers: [
    AuthGuard,
    AdminAuthGuard
  ],
})
export class SharedModule { }
